// Matches GET /conversations/archive — see conversation-analytics-archive-api.md
export type ArchiveStatus = "open" | "closed";

export interface ArchivedConversation {
  id: string;
  contact: {
    name: string;
    phone: string;
    email: string;
  };
  recent_message: string;
  start_date: string; // ISO date string
  end_date: string; // ISO date string
  status: ArchiveStatus;
  assigned_by: string;
  archived_at: string;
  archived_by_user_id: string;
}

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const formatArchiveDate = (iso: string) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return `${d.getDate()} ${MONTHS[d.getMonth()]}, ${d.getFullYear()}`;
};
